
// Define a regular expression pattern for MM/DD/YYYY format
const dateFormatPattern = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(?:\d{4}|\d{2})$/;

export const isValidDateFormat = (value : any) => {

    let formattedDate = value;
    // Check if the value matches the expected format
    if (dateFormatPattern.test(formattedDate)) {
        // If it matches, split the value into month, day, and year
        const [month, day, year] = formattedDate.split('/');

        // Convert the components to integers
        const parsedMonth = parseInt(month, 10);
        const parsedDay = parseInt(day, 10);
        const parsedYear = parseInt(year, 10);

        // Check if the components represent a valid date
        if (
            parsedMonth >= 1 && parsedMonth <= 12 &&
            parsedDay >= 1 && parsedDay <= 31 &&
            parsedYear >= 1000 && parsedYear <= 9999
        ) {
            return true;
        }
    }
    return false;
}
